<template>
  <div class="admin-filter">
    <div v-if="isNeeded('title')">
      <input-text
        :label="$tc('activities.activity', 1)"
        @update-value="updateFilter('title', $event)"
      />
    </div>
    <div v-if="isNeeded('activity_category_id')">
      <input-select
        :label="$t('general.category')"
        :options="activityCategories"
        optionlabel="title"
        optionvalue="id"
        :value="filters.activity_category_id"
        @update-value="updateFilter('activity_category_id', $event)"
      />
    </div>
    <div v-if="isNeeded('active')">
      <select name="active" id="active" v-model="filters.active" @change="emitFilter">
        <option :value="null">alle</option>
        <option :value="true">active</option>
        <option :value="false">inactive</option>
      </select>
    </div>
  </div>
</template>

<script>
const InputText = require("@/modules/input/components/InputText.vue").default;
const InputSelect = require("@/modules/input/components/InputSelect.vue")
  .default;

export default {
  name: "WdFilter",
  data() {
    return {
      activityCategories: null,
      filters: {
        title: null,
        active: null,
        activity_category_id: null
      }
    };
  },
  props: {
    filterArray: {
      type: Array
    },
    initialValues: {
      type: Object,
      default: () => {
        return null;
      }
    }
  },
  components: {
    InputText,
    InputSelect
  },
  methods: {
    updateFilter(Element, Value) {
      this.filters[Element] = Value;
      let outObj = {};
      this.fArray.forEach(e => {
        outObj[e] = this.filters[e];
      });
      this.$emit("filter-input", outObj);
    },
    isNeeded(property) {
      return this.fArray ? this.fArray.find(e => e === property) : true;
    }
  },
  computed: {
    fArray() {
      if (!this.filterArray || this.filterArray.length < 1) {
        return Object.keys(this.filters);
      }
      return this.filterArray;
    }
  },
  async created() {
    if (this.isNeeded("activity_category_id")) {
      this.activityCategories = await this.$store.getters[
        "activitycategory/api"
      ].GetAll();
      this.activityCategories.unshift({
        id: "all",
        title: this.$t("general.all")
      });
    }
  },
  watch: {
    initialValues: {
      immediate: true,
      handler(newVal) {
        if (newVal) {
          Object.assign(this.filters, newVal);
        }
      }
    }
  }
};
</script>

<style scoped>
.admin-filter {
  margin: 1em 0;
  display: grid;
  grid-template-columns: repeat(auto-fit, minMax(200px, 1fr));
  grid-gap: 0.3em;
}
</style>
